<template lang="html">
  <div class="fullScreen data">
    <common-header></common-header>
    <div class="page">
      <div class="wrapper-content">
        <div class="ibox-title">
          <div class="btn btn-info" @click="$router.push('/applyForm')" v-if="role == 2">
            资料录入
          </div>
        </div>
        <div class="box box_dataTypein">
          <div class="row search">
            <div class="col-sm-6 col-md-5 col-lg-3">
              <div class="form-group row no-gutters">
                <label for="staticEmail" class="col-form-label">姓名：</label>
                <div class="col-sm-7">
                  <input type="text" class="form-control" placeholder="" v-model="name" />
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-5 col-lg-3">
              <div class="form-group row no-gutters">
                <label for="staticEmail" class="col-form-label">职称：</label>
                <div class="col-sm-7">
                  <input type="text" class="form-control" placeholder="" v-model="positiontitle" />
                  <!-- <select id="inputState" class="form-control" v-model="positiontitle">
                    <option value=""></option>
                    <option v-for="item in posiTitle" :value="item">{{item}}</option>
                  </select> -->
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-5 col-lg-3">
              <div class="form-group row no-gutters">
                <label for="staticEmail" class="col-form-label">政治面貌：</label>
                <div class="col-sm-7">
                  <select id="inputState" class="form-control" v-model="political">
                    <option value=""></option>
                    <option v-for="item in politicalBackground" :value="item.name">{{ item.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-5 col-lg-3">
              <div class="form-group row no-gutters">
                <label for="staticEmail" class="col-form-label">审核状态：</label>
                <div class="col-sm-7">
                  <select id="inputState" class="form-control" v-model="checkstats">
                    <option value=""></option>
                    <option v-for="item in checkstatsArr" :value="item.name">{{
                      item.name
                    }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-sm-7 col-md-7 col-lg-4">
              <div class="form-group row no-gutters">
                <label for="staticEmail" class="col-form-label">申请时间：</label>
                <div class="col-sm-7" style="width: 100%;max-width: 80%;flex: 1;">
                  <el-date-picker style="width: 100%;" v-model="intimeArr" type="datetimerange" range-separator="-"
                    start-placeholder="开始日期" end-placeholder="结束日期">
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-5 col-lg-3" v-if="role == 1">
              <div class="form-group row no-gutters">
                <label for="staticEmail" class="col-form-label">协会分类：</label>
                <div class="col-sm-7">
                  <select id="inputState" class="form-control" v-model="un">
                    <option value=""></option>
                    <option v-for="item in group" :value="item.title">{{
                      item.title
                    }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-sm-7 col-md-7 col-xs-12 col-lg-6">
              <div class="form-group row no-gutters">
                <label for="staticEmail" class="col-form-label">出生年月：</label>
                <div class="col-sm-4 col-xs-4 position-relative">
                  <input type="text" class="form-control" placeholder="" v-model="birthdate1"
                    @click.stop.prevent="showDatepicker" />
                  <date-picker v-bind:show="datepickerShow" v-on:getChildDate="catchChildDate"></date-picker>
                </div>
                <div class="col-sm-1 text-center" style="line-height:2">
                  <span>-</span>
                </div>
                <div class="col-sm-4 col-xs-4  position-relative">
                  <input type="text" class="form-control" placeholder="" v-model="birthdate2"
                    @click.stop.prevent="showEndDatepicker" />
                  <date-picker v-bind:show="datepickerEndShow" v-on:getChildDate="catchChildEndDate"></date-picker>
                </div>
                <!-- <div class="col-sm-1 text-center">
                  <span class="line">-</span>
                </div>
                <div class="col-sm-4">
                  <input type="text" class="form-control"  placeholder="">
                </div> -->
              </div>
            </div>
            <div class="col-sm-auto">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="radio" v-model="Class" id="inlineCheckbox4" value=""
                  value="option1" checked />
                <label class="form-check-label" for="inlineCheckbox4">全部</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="radio" v-model="Class" id="inlineCheckbox1"
                  value="n" />
                <label class="form-check-label" for="inlineCheckbox1">国家级会员</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="radio" id="inlineCheckbox2" value="p"
                  v-model="Class" />
                <label class="form-check-label" for="inlineCheckbox2">省级会员</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="radio" id="inlineCheckbox3" value="c"
                  v-model="Class" />
                <label class="form-check-label" for="inlineCheckbox3">市级会员</label>
              </div>
            </div>
            <div class="ml-md-auto">
              <div class="btn btn-primary" @click="search">
                搜索
              </div>
              <div class="btn btn-info" @click="download">
                导出结果
              </div>
            </div>
          </div>
          <div class="ml-md-auto" style="margin-bottom: 10px">
            <div class="btn btn-primary" @click="search('pinyin')">
              拼音顺序
            </div>
            <div class="btn btn-primary" @click="search('code')">
              编号排序
            </div>
          </div>
          <div class="row table-content">
            <div class="col-sm-12" role="region" aria-labelledby="caption" tabindex="0">
              <p v-if="!list.length" class="no-result">无结果</p>
              <table class="table" v-if="list">
                <thead class="">
                  <tr scope="row" class="text-center">
                    <th scope="col">申请编号</th>
                    <th scope="col">协会名称</th>
                    <th scope="col">申请时间</th>
                    <th scope="col">申请人</th>
                    <th scope="col">状态</th>
                    <th scope="col">备注</th>
                    <th scope="col">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="text-center" v-for="item in list">
                    <th scope="row">{{ item.id }}</th>
                    <th>{{ item.union }}</th>
                    <td>{{ item.intime }}</td>
                    <td>{{ item.name }}</td>
                    <td>
                      <span :class="checkStatus(item.status)">{{
                        item.status
                      }}</span>
                    </td>
                    <td>
                      <span v-if="item.remark && item.remark.length > 10" class="remark-short" @click="showRemarkModal(item.remark)" title="点击查看完整备注">
                        {{ item.remark.substring(0, 10) }}...
                      </span>
                      <span v-else>{{ item.remark || '-' }}</span>
                    </td>
                    <td class="width-25" style="text-align:left;width:15%;min-width:180px;">
                      <a href data-toggle="modal" data-target="#checkBox" @click="
                        changeCurrentId(item.id, checkStatus(item.status))
                        " v-if="checkStatus(item.status) == 'state2' ||
                          checkStatus(item.status) == 'state3'
                        ">{{
                          checkStatus(item.status) == "state2" ? "初审" : "终审"
                        }}</a><a @click.stop.prevent="goDetail(item.id)" href>查看</a><a v-if="item.editable"
                        @click.stop.prevent="goEdit(item)" href>修改</a>
                      <!-- <a href v-if="item.status == '终审通过' || item.status == '初审通过'
                          " @click="print(item.id)">打印</a> -->
                      <a href v-if="item.status == '终审通过'" @click.stop.prevent="goCard(item.id)">电子会员证</a>
                      <a href @click.stop.prevent="delItem(item.id)">删除</a>
                    </td>
                    <!--  -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row justify-content-md-center">
            <page-ctrl v-bind:totalPage="totalPage" v-bind:currentPage="currentPage"
              v-on:catchPage="catchPage"></page-ctrl>
          </div>
        </div>
      </div>
      <!-- model -->
      <div class="modal fade" id="checkBox" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">审核</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p style="margin-bottom:20px;padding-left:22px;">
                是否通过{{ currentState == "state2" ? "初审" : "终审" }}？
              </p>

              <div class="form-group row no-gutters" v-if="mumber">
                <div class="col-sm-12 row no-gutters">
                  <label for="member" class="col-sm-3 col-form-label">会员编号：</label>
                  <div class="col-sm-8 ">
                    <input type="text" id="member" class="form-control" v-model="membered" placeholder="" />
                  </div>
                </div>
              </div>
              <div class="form-group row no-gutters">
                <label for="staticEmail" class="col-sm-3 col-form-label">备注：</label>
                <div class="col-sm-8 position-relative">
                  <textarea type="text" class="form-control" maxlength="50" v-model="remark" placeholder="拒绝时必填"
                    style="resize:none;"></textarea>
                </div>
              </div>

              <div class="form-group row no-gutters">
                <label for="staticEmail" class="col-sm-3 col-form-label">协会咨询方式：</label>
                <div class="col-sm-8 position-relative">
                  <input type="text" class="form-control" maxlength="36" v-model="contact" placeholder="拒绝时必填"
                    style="resize:none;" />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="checkView(2)">
                拒绝
              </button>
              <button type="button" class="btn btn-primary" @click="checkView(1)">
                通过
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- 备注详情弹窗 -->
      <div class="modal fade" id="remarkModal" tabindex="-1" role="dialog" aria-labelledby="remarkModalTitle"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="remarkModalTitle">备注详情</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p style="white-space: pre-wrap; word-break: break-all;">{{ currentRemark }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <alert-model v-bind:func="alertFunc" v-bind:show="alertShow" v-on:close="catchClose"
      v-bind:msg="tips"></alert-model>
  </div>
</template>

<script>
import commonHeader from "./header.vue"
import pageCtrl from "./pagination.vue"
import datePicker from "./datepicker.vue"
import alertModel from "./alert.vue"
export default {
  name: "dataTypein",
  data() {
    return {
      alertFunc: "",
      role: "",
      posiTitle: [],
      list: "",
      totalPage: 0,
      currentPage: 0,
      currentId: "",
      currentState: "",
      datepickerShow: false,
      datepickerEndShow: false,
      politicalBackground: politicalBackground,
      political: "",
      name: "",
      positiontitle: "",
      Class: "",
      birthdate1: "",
      birthdate2: "",
      membered: "",
      alertShow: false,
      tips: "",
      remark: "",
      contact: "",
      order: "",
      checkstats: "",
      checkstatsArr: [
        { name: "待审核" },
        { name: "初审通过" },
        { name: "初审未通过" },
        { name: "终审通过" },
        { name: "终审未通过" }
      ],
      order: "",
      group: [],
      un: "",
      timers: "",
      payFlag: false,
      code: "",
      trade_no: "",
      intimeArr: [],
      currentRemark: ""
    }
  },
  components: {
    commonHeader,
    pageCtrl,
    datePicker,
    alertModel
  },
  computed: {
    mumber() {
      if (this.currentState == "state3") {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    showRemarkModal(remark) {
      this.currentRemark = remark || ""
      $("#remarkModal").modal("show")
    },
    catchClose(data) {
      this.alertShow = data.show
    },
    alert(msg, func) {
      this.alertShow = true
      this.tips = msg
      this.alertFunc = func
    },
    download() {
      // let params = `name=${this.name}&positiontitle=${this.positiontitle}&class=${this.Class}&birthdate1=${this.birthdate1}&birthdate2=${this.birthdate2}&political=${political}&order=${this.order}&checkstats=${this.checkstats}&un=${this.un}`
      // window.location.href = 'http://app.shiminjia.com/api/wenlian/dlmem?'
      // let url = 'http://app.shiminjia.com/api/wenlian/dlmem'
      let params = {
        name: this.name,
        positiontitle: this.positiontitle,
        class: this.Class,
        birthdate1: this.birthdate1,
        birthdate2: this.birthdate2,
        political: this.political,
        order: this.order,
        checkstats: this.checkstats,
        un: this.un,
        start_time: this.intimeArr && this.intimeArr.length > 0 ? this.intimeArr[0] : '',
        end_time: this.intimeArr && this.intimeArr.length > 0 ? this.intimeArr[1] : '',
      }
      this.$axios
        .post(`/api/wenlian/dlmem`, this.qs.stringify(params))
        .then(res => {
          if (res.data.result == 1) {
            window.location.href = "https://app.shiminjia.com" + res.data.url
          } else {
            this.alert(res.data.msg)
          }
        })
    },
    print(id) {
      window.open(`https://app.shiminjia.com/api/wenlian/print?id=${id}`)
    },
    showDatepicker() {
      this.datepickerEndShow = false
      this.datepickerShow = !this.datepickerShow
    },
    catchChildDate(date) {
      console.log(date)
      this.birthdate1 = date.date
      this.datepickerShow = false
      this.datepickerEndShow = false
    },
    showEndDatepicker() {
      this.datepickerShow = false
      this.datepickerEndShow = !this.datepickerEndShow
    },
    catchChildEndDate(date) {
      this.birthdate2 = date.date
      this.datepickerShow = false
      this.datepickerEndShow = false
    },
    checkView(Stats) {
      if (Stats == 2 && (!this.remark || !this.contact)) {
        this.alert("拒绝时备注和咨询方式必填");
        return;
      }
      if (this.currentState == "state2") {
        let params = {
          id: this.currentId,
          stats: Stats,
          remark: this.remark,
          contact: this.contact
        }
        this.$axios
          .post("/api/wenlian/firstreview", this.qs.stringify(params))
          .then(res => {
            if (res.data.result == 1) {
              this.alert(res.data.msg, () => {
                // window.location.reload()
                $("#checkBox").modal("hide")
                this.search()
              })
            } else {
              this.alert(res.data.msg)
            }
          })
      } else {
        let params = {
          id: this.currentId,
          stats: Stats,
          memberid: this.membered,
          remark: this.remark,
          contact: this.contact
        }
        this.$axios
          .post("/api/wenlian/finalreview", this.qs.stringify(params))
          .then(res => {
            if (res.data.result == 1) {
              this.alert(res.data.msg, () => {
                // window.location.reload()
                $("#checkBox").modal("hide")
                this.search()
              })
            } else {
              this.alert(res.data.msg)
            }
          })
      }
    },
    delItem(id) {
      let result = window.confirm("确认删除?");
      if (!result) {
        return;
      }
      this.$axios
        .post("/api/wenlian/delrequest", 'id=' + id)
        .then(res => {
          if (res.data.result == 1) {
            this.alert(res.data.msg, () => {
              this.search()
            })
          } else {
            this.alert(res.data.msg)
          }
        })
    },
    changeCurrentId(id, state) {
      this.currentId = id
      this.currentState = state
    },
    checkStatus(status) {
      const statusGroup = [
        "待提交",
        "待审核",
        "初审通过",
        "初审未通过",
        "终审通过",
        "终审未通过"
      ]
      let index = statusGroup.indexOf(status)
      if (status == "已缴费") {
        index = 2
      }
      return `state${index + 1}`
    },
    catchPage(data) {
      let p = data.p
      console.log(data)
      let params = {
        name: this.name,
        positiontitle: this.positiontitle,
        class: this.Class,
        birthdate1: this.birthdate1,
        birthdate2: this.birthdate2,
        political: this.political,
        order: this.order,
        checkstats: this.checkstats,
        un: this.un
      }
      this.$axios
        .post(`/api/wenlian/requestlist?page=${p}`, this.qs.stringify(params))
        .then(res => {
          this.list = res.data.data
          this.totalPage = res.data.sumpage
          this.currentPage = res.data.curpage
        })
    },
    goDetail(id) {
      //this.$router.push({ path: "/detail", query: { id: id } })
      this.$router.push({ path: "/table", query: { id: id } })
    },
    goEdit(item) {
      if (item.status == "终审通过") {
        this.$router.push({ path: "/edit2", query: { id: item.id } })
      } else {
        this.$router.push({ path: "/edit", query: { id: item.id } })
      }
    },
    goCard(id) {
      window.open("https://app.shiminjia.com/api/wenlian/card?id=" + id)
    },
    search(order) {
      this.order = order
      let params = {
        name: this.name,
        positiontitle: this.positiontitle,
        class: this.Class,
        birthdate1: this.birthdate1,
        birthdate2: this.birthdate2,
        political: this.political,
        order: this.order,
        checkstats: this.checkstats,
        un: this.un,
        start_time: this.intimeArr && this.intimeArr.length > 0 ? this.intimeArr[0] : '',
        end_time: this.intimeArr && this.intimeArr.length > 0 ? this.intimeArr[1] : '',
      }
      this.$axios
        .post(`/api/wenlian/requestlist?page=1`, this.qs.stringify(params))
        .then(res => {
          this.list = res.data.data
          this.totalPage = res.data.sumpage
          this.currentPage = res.data.curpage
        })
    }
  },
  mounted() {
    this.posiTitle = posiTitle
    this.group = group
    if (this.$store.state.user.role == 3) {
      this.$router.push("/")
    } else {
      this.$axios.get(`/api/wenlian/requestlist?page=1`).then(res => {
        this.list = res.data.data
        this.totalPage = res.data.sumpage
        this.currentPage = res.data.curpage

        // this.list = [{ "id": "5887", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": " \u5f20\u660e\u8f69", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "6017", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u5b89\u53ef\u5b9d", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "6130", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u5b89\u6dde\u6e24", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "5158", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u5b89\u7389\u6885", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "4925", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u5b89\u4ef2\u946b", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "6010", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u5b89\u4ef2\u794e", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "5246", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u73ed\u6606", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "5077", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u9c8d\u519b\u6d9b", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "5210", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u8fb9\u957f\u987a", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "5129", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u535e\u4eac\u660e", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "4911", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u6bd5\u53ef\u56fd", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "5214", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u6bd5\u73b2\u5e86", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "5663", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u90b4\u5409\u6770", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "6236", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u90b4\u4e3d\u5a1c", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "6283", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u6bd5\u5584\u56fd", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "5851", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u6bd5\u4ed5\u4f1f", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "5424", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u6bd5\u5146\u4e1a", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "5679", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u6bd5\u5fd7\u6210", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "5438", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u6bd5\u5b50\u950b", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }, { "id": "5458", "userid": "29", "union": "\u9752\u5c9b\u5e02\u7f8e\u672f\u5bb6\u534f\u4f1a", "intime": "2020-10-13 13:22", "name": "\u535c\u8303\u52cb", "status": "\u7ec8\u5ba1\u901a\u8fc7", "remark": "", "editable": 1, "isPaid": 0, "statusCode": 4 }]
      })
    }
    this.role = this.$store.state.user.role
  }
};
</script>

<style lang="css" scoped>
.remark-short {
  cursor: pointer;
  color: #18a689;
  text-decoration: underline;
}
.remark-short:hover {
  color: #147a63;
}
.data .modal .btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show>.btn-primary.dropdown-toggle {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}

.data .modal .btn-primary {
  background-color: #18a689;
  border-color: #18a689;
}

.btn-primary {
  background-color: #18a689;
  border-color: #18a689;
}

.data .btn-primary:hover {
  background-color: #1ab394;
  border-color: #1ab394;
}

.btn-primary:hover {
  background-color: #1ab394;
  border-color: #1ab394;
}

.data .ibox-title .btn {
  padding-left: 40px;
  padding-right: 40px;
}

.data.fullScreen {
  height: 100%;
}

.data .table {
  border: 1px solid #33434b;
}

.data .table tbody tr:nth-child(2n) {
  background: #fff;
}

.data .table tbody tr:nth-child(2n-1) {
  background: #f9f9f9;
}

.data .state1 {
  color: #333;
}

.data .state2 {
  color: red;
}

.data .state3,
.data .state5 {
  color: green;
}

.data td>a {
  margin: 0 10px;
}

.data thead {
  background: #fff;
  color: #33434b;
}

.data tbody,
.page-link {
  color: #33434b;
}

.data .page-link:hover {
  background: #f4f4f4;
  color: #33434b;
}

.data .page-link.active {
  background: #f4f4f4;
}

.data .table thead th {
  vertical-align: middle;
}

.data .search {
  width: 100%;
  padding: 20px;
  border: 1px solid #a9afb5;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 20px;
}

.data .line {
  font-size: 18px;
  color: #333;
  text-align: center;
  line-height: 2;
}

.data .form-group label {
  font-size: 14px;
  color: #33434b;
}

.data input,
.data select,
.data .textarea,
.data .form-check label {
  color: #33434b;
  font-size: 15px;
}

.data .ml-md-auto .btn {
  width: 100px;
  margin-right: 15px;
}

.data .form-check label {
  line-height: 3;
}

.data .table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #33434b;
}

.width-25 {
  width: 25%;
}

/*.data .btn-primary:not(:disabled):not(.disabled).active,.data .btn-primary:not(:disabled):not(.disabled):active,.data .show>.btn-primary.dropdown-toggle{opacity: 0.5;background-color: #18a689;border-color: #18a689;}
.data .btn-primary{background-color: #18a689;border-color: #18a689;width: 200px;}
.data .btn-primary:hover{background-color: #1ab394;border-color: #1ab394;}
.data .btn-primary.disabled{opacity: 0.5;background-color: #18a689;border-color: #18a689;}*/
.page {
  padding: 20px 0;
}

.wrapper-content {
  max-width: 1400px;
  margin: 0 auto;
}

@media screen and (max-width: 750px) {
  .box_dataTypein .ml-md-auto {
    margin: 0 auto;
  }

  .box_dataTypein .table-content {
    margin: 0;
  }

  .box_dataTypein .table {
    width: 1000px;
    table-layout: fixed;
    border: none !important;
    border-collapse: separate;
    border-spacing: 0;
  }

  .box_dataTypein .table thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    width: 25vw;
    background: white;
  }

  .box_dataTypein .table thead th:first-child {
    /* position: sticky; */
    /* left: 0; */
    /* z-index: 10; */
    border-left: 1px solid #a9afb5;
    /* box-shadow: 0 0 10px rgb(0 0 0 / 12%); */
    width: 50px !important;
  }

  .box_dataTypein .table thead th:nth-child(2) {
    position: sticky;
    left: 0;
    z-index: 10;
    border-left: 1px solid #a9afb5;
    box-shadow: 0 0 10px rgb(0 0 0 / 12%);
    /* width: 50px; */
  }

  .box_dataTypein .table tbody th {
    border-left: 1px solid #a9afb5;
  }

  .box_dataTypein .table tbody th:nth-child(2) {
    position: sticky;
    left: 0;
    background: white;
    z-index: 9;

    box-shadow: 0 0 10px rgb(0 0 0 / 12%);
  }

  [role='region'][aria-labelledby][tabindex] {
    width: 450px;
    height: 400px;
    overflow: auto;
    padding: 0;
    outline: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataTypein.vue